/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { RESEND_CREDENTIAL } from '@pages/PayoutListPage/apis/graphql';
import { notificationsPayoutListConfig } from '../../config/notifications.config';
import { Graphql } from '@common/graphql';
import { apiConfig } from '@pages/PayoutListPage/config/api.config';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator/services';
import { useEventId } from '../../provider';
import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ResendCredentialProps {
  id: string;
  sendToEmail: boolean;
  sendToWallet: boolean;
}

export interface IResentCredentialMethods extends IPluginMethodMap {
  getResentCredentialProps(args: any): Promise<any>;
}

export class ResentCredentialPlugin implements IAgentPlugin {
  readonly methods: IResentCredentialMethods;

  constructor() {
    this.methods = {
      getResentCredentialProps: this.getProps.bind(this),
    };
  }

  async getProps(args: ResendCredentialProps) {
    //return await this.getResentCredential(args);
    return { ...notificationsPayoutListConfig };
  }

  private async getResentCredential(args: any) {
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      let _thr =
        args?.sendToEmail && args?.sendToWallet
          ? 'BOTH'
          : args?.sendToEmail
          ? 'EMAIL'
          : args?.sendToWallet
          ? 'WALLET'
          : null;
      const client = gql.getClient();
      const res = await client
        .mutation(RESEND_CREDENTIAL, {
          input: {
            id: args?.id,
            thr: _thr,
          },
        })
        .toPromise();
      if (res?.data?.resendCredential?.message) {
        return {
          notification: notificationsPayoutListConfig?.resendCredential,
        };
      }
    } catch (err: any) {
      throw err;
    }
  }
  private formatTable(tableData: any) {
    let _rowData =
      Array.isArray(tableData) &&
      tableData.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyId,
          vid: item?.purchaser?.vuid,
          status: item?.status,
          payout: item?.amount,
          policyNo: item?.policyNumber,
          name: `${item?.purchaser?.firstName} ${item?.purchaser?.lastName}`,
          email: item?.purchaser?.email,
          // image:item?.image,
          dateCreated: item?.policy?.purchasedAt
            ? moment(item?.policy?.purchasedAt).format('LLL')
            : '-',
          coverage: item?.policy?.coverage,
          premium: item?.policy?.premium,
          policyOption: `Policy Option ${item?.policy?.productDefination}`,
        };
      });
    return _rowData;
  }
}
